"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const ro = require("redux-observable");
const all_1 = require("./all");
exports.allEpics = ro.combineEpics(all_1.getAll);
//# sourceMappingURL=index.js.map